import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieVideoLangForm, useSerieVideoLang } from '@/features/series-video-lang-management';
import { Skeleton } from '@/shared/ui/atoms';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute(
  '/_authenticated/series/$serieId/videos/$videoId/langs/$langId/',
)({
  component: SerieVideoLangEditPage,
});

/** Página de edição de Idioma do Vídeo. */
export function SerieVideoLangEditPage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam, videoId: videoIdParam, langId } = Route.useParams();
  const videoId = Number(videoIdParam);
  const navigate = useNavigate();

  const { lang, isLoading } = useSerieVideoLang(videoId, Number(langId));

  const goBack = () =>
    void navigate({
      to: '/series/$serieId/videos/$videoId/langs',
      params: { serieId: serieIdParam, videoId: videoIdParam },
    });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('videoLangs.form.editTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('videoLangs.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/videos" params={{ serieId: serieIdParam }}>
                {t('videoLangs.breadcrumb.videos')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link
                to="/series/$serieId/videos/$videoId/langs"
                params={{ serieId: serieIdParam, videoId: videoIdParam }}
              >
                {t('videoLangs.breadcrumb.langs')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('videoLangs.form.editTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {isLoading ? (
        <Skeleton className="h-[380px] w-full rounded-sm" />
      ) : (
        <SerieVideoLangForm
          videoId={videoId}
          lang={lang ?? null}
          onSaved={goBack}
          onCancel={goBack}
        />
      )}
    </div>
  );
}
